/* eslint-disable no-console */
/* eslint-disable max-len */
import { useDispatch } from 'react-redux';
import '../../UiStyles/RightSlider/styles.css';
import '../../containers/BusinessSettings/styles.css';
import { getCertificateRedux, getExamRedux, getMarkingRedux, getQuestionBankRedux, getQuestionRedux, getTemplateRedux } from '../../redux/CertificationRedux';
import { resetChat } from '../../redux/ChatRedux';
import { getReminderRedux, getTaskRedux } from '../../redux/CollaborationRedux';
import { getDealRedux, getOthersDealRedux } from '../../redux/DealRedux';
import { getDepartmentRedux, getEmployeeIdRelation } from '../../redux/DepartmentRedux';
import { getEmployeeRedux } from '../../redux/EmployeeRedux';
import { resetMyresourcesData } from '../../redux/MyResourceRedux';
import { MarkingTab, certifciteTab, getCatRelations, getConnectionData, getNetworkRelations, getSuggestions, setFeedNetworkRelation, setFollowPopup } from '../../redux/NetworkRedux';
import { resetFeed } from '../../redux/NewsFeedRedux';
import { fetchRecogniseData } from '../../redux/RecogniseRedux';
import { fetchResourceData } from '../../redux/ResourceRedux';
import { updateMeetingData } from '../../redux/TrainingRedux';
import { getCompanyProfileData, getDealData, getNotification, getNotificationRedux, getSessionCount, getSharedItem, getUserSession, updateSideMenu, resetUserSession } from '../../redux/UserSessionSlice';
import { resetPresenceRedux } from '../../redux/PresenceRedux';

const useStoreEmpty = () =>
{
	const dispatch = useDispatch();
	const emptyReduxState = () =>
	{
		console.log('calling**');

		dispatch(resetFeed());
		dispatch(resetUserSession())
		dispatch(getUserSession({}));
		dispatch(certifciteTab(0));
		dispatch(MarkingTab(0));
		dispatch(getDealData({ dealConnection: 0, dealStatus: false }));
		dispatch(resetChat());
		dispatch(getNetworkRelations({ initialCount: 0, relations: [] }));
		dispatch(getConnectionData({ value: 0, connectionCount: 0, mynetwork: [], pending: [], follow: [], block: [] }));
		dispatch(getNetworkRelations({ initialCount: 0, relations: [] }));
		dispatch(getSuggestions([]));
		dispatch(getDepartmentRedux({ departments: [], relations: [], divisions: [], designations: [], departmentView: {}, employeeCount: [] }));
		dispatch(getExamRedux([]));
		dispatch(getCatRelations([]));
		dispatch(getMarkingRedux({ publish: [], unPublish: [] }));
		dispatch(getQuestionRedux([]));
		dispatch(getQuestionBankRedux({ publish: [], unPublish: [] }));
		dispatch(getTemplateRedux({ publish: [], unPublish: [] }));
		dispatch(getCertificateRedux({ publish: [], unPublish: [] }));
		dispatch(getDealRedux({ approved: [], pending: [], reject: [], expired: [] }));
		dispatch(getOthersDealRedux({ approved: [], pending: [], reject: [], expired: [] }));
		dispatch(getCompanyProfileData('clear'));
		dispatch(getEmployeeRedux({ active: [], pending: [], reject: [], managers: [] }));
		dispatch(getTaskRedux({ pending: [], complete: [] }));
		dispatch(getReminderRedux({ upcoming: [], history: [] }));
		dispatch(getNotificationRedux({ notification: [] }));
		dispatch(setFeedNetworkRelation({ page: 0, relations: [] }));
		dispatch(fetchResourceData({
			categories        : [],
			subCategories     : [],
			content           : [],
			sections          : [],
			networkCategories : [],
			categoryData      : {}
		}));
		dispatch(setFollowPopup({ follow: [], following: [], mutual: [], companyId: '' }));
		dispatch(getSessionCount(0));
		dispatch(getNotification(0));
		dispatch(fetchRecogniseData({ published: [], unpublished: [], recognise: false }));
		dispatch(getSharedItem(''));
		dispatch(updateMeetingData({
			upcomingMeetings : [],
			pastMeetings     : [] }
		));
		dispatch(resetMyresourcesData());
		dispatch(getEmployeeIdRelation(null));
		dispatch(updateSideMenu([]));
		dispatch(resetPresenceRedux());
	};

	return emptyReduxState;
};

export default useStoreEmpty;
